import styled from 'styled-components'

export const Background = styled.div`
  position: absolute;
  bottom: 0;

  background: rgba(115, 202, 228, 0.9);

  display: block;
  width: 100%;
  height: 7%;
  z-index: 1;
  clip-path: polygon(0 0, 100% 5%, 100% 100%, 0 100%);

  @media screen and (max-width: 812px) {
    position: initial;
    height: 45px;
  }
`

export const Highlight = styled.div`
  position: absolute;
  bottom: 0;

  background: rgba(219, 239, 245, 0.9);

  display: block;
  width: 100%;
  height: 95%;
  z-index: 10;
  clip-path: polygon(0 19%, 100% 8%, 100% 100%, 0 100%);

  @media screen and (max-width: 812px) {
    position: initial;
    height: 45px;
  }
`

export const Copyright = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  height: 100%;

  color: rgba(5, 75, 130, 1);
  text-align: center;
  font-size: 0.8em;
  font-family: 'Barthowheel-Regular';

  > p {
    display: block;
    width: 100%;
  }
`